module.exports = __webpack_public_path__ + "img/bgIllustration.b6bd2df7.png";